<template>
  <div>
    <a-row :gutter="[16, 16]">
      <a-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 8 }">
        <listDesign />
      </a-col>
      <a-col :xs="{ span: 24 }" :sm="{ span: 24 }" :md="{ span: 24 }" :xl="{ span: 16 }">
        <!-- :logAbsent="logAbsent"
          :logFlex="logFlex"
          :logWFH="logWFH"
          :logHolidayList="logHolidayList"
          :logSeminar="logSeminar" -->
        <calendar :arrDate="arrDate" :logBooking="logBooking" @sendDateTimeFormat="sendDateTimeFormat"
          @viewBooking="viewBooking" :isCalendarLoaded="isCalendarLoaded" />
      </a-col>
    </a-row>

    <a-modal v-model="isShowModalBookingInfo" title="Booking Details" cancel-text="Close"
      @ok="isShowModalBookingInfo = false">
      <div v-if="!isLoadedBookingInfo && !isEmptyBooking" class="div-isLoaded">
        <a-spin />
      </div>
      <div class="modal-info" v-if="isLoadedBookingInfo && !isEmptyBooking">
        <div v-for="(data, index) in listOfBooking" :key="'data' + index">
          <p style="text-align: right;" v-if="listOfBooking.length > 1">
            <strong>{{ index + 1 }}</strong>
          </p>
          <div>
            <strong>Detail : </strong>
            <p class="mt-5 mb-10">
              {{ data.detail_of_design }}
            </p>
          </div>

          <div>
            <strong>Deadline : </strong>
            <p class="mt-5 mb-5">
              {{ moment(data.deadline_date).format("DD / MM / YYYY") }}
            </p>
          </div>
          <div>

            

            <strong>Requestor : </strong>
            <p class="mt-5 mb-10">
              {{
                data.requester_staff_detail.name + ' ' + data.requester_staff_detail.surname + ', tel : ' +
                data.requester_staff_detail.telephone
              }}
              <br>
            </p>
          </div>
          <div v-if="data.status === 'approve' || data.status === 'success'">
            <strong>Staff Coordinator : </strong>
            <span v-for="(staff_data, index) in data.staff_support_detail" :key="'staff_' + index">
              <p class="mt-5 mb-10">
                - {{
                  staff_data.staff_name + ', tel : ' + staff_data.telephone
                }}
                <br>
              </p>
            </span>
          </div>
          <div>
            <strong>Created At: </strong>
            <p class="mt-5 mb-5">
              {{ moment(data.created_at).format("DD / MM / YYYY , HH:mm") }}
            </p>
          </div>
          <div>
            <strong>Status : </strong>
            <a-tag :color="data.status === 'wait'
              ? '#ffc71e'
              : (data.status === 'approve'
                ? '#4C6793'
                : (data.status === 'success' ? '#87d068' : 'red'))
              ">
              {{ data.status }}
            </a-tag>
          </div>
          <hr v-if="listOfBooking.length > 1 && index != listOfBooking.length - 1">
        </div>
      </div>
      <div v-if="isLoadedBookingInfo && isEmptyBooking">
        <a-empty><span slot="description">
            No Booking.
          </span></a-empty>
      </div>
    </a-modal>

  </div>
</template>

<script>
import calendar from "./calendar.vue";
import listDesign from "./list-design.vue";
import { prBookingMainMixin } from "@/mixins/prBookingMainMixin";

const formData = {
  content: "",
  remark: "",
  destination: "",
  requestor: "",
  use_start: "",
  use_end: "",
}
export default {
  mixins: [prBookingMainMixin],
  components: {
    calendar,
    listDesign,
  },
  data() {
    return {
      objData: Object.assign({}, formData),
      apiBasePath: '/booking/design/calendar/',
    };
  },
  mounted() {
    this.sendDateTimeFormat("start");
  },
  methods: {
    resetFormData() {
      this.objData = Object.assign({}, formData);
    },

  },
};
</script>

<style scoped>
.div-isLoaded {
  text-align: center;
  border-radius: 4px;

  padding: 30px 50px;
  margin: 20px 0;
}

.modal-info {
  overflow-y: scroll;
  max-height: 600px;
}

.readText {
  white-space: pre-line;
}
</style>